import React from 'react';
import ReactDOM from 'react-dom';

interface PortalLoaderProps {
  dataAttr: string;
  Component: any;
}

const PortalLoader: React.FC<PortalLoaderProps>= (props: PortalLoaderProps) => {
  const { dataAttr, Component } = props;
  const nodes: NodeListOf<HTMLElement> = document.querySelectorAll(`[${dataAttr}]`);

  if (!nodes || nodes.length === 0) {
    return null;
  }

  return (
    <>
      {Array.from(nodes).map((node, index) => (
        ReactDOM.createPortal(
          <Component dataSet={node.dataset} />,
          node,
          `${dataAttr}-${index}`
        )
      ))}
    </>
  );
}

export default PortalLoader;